<template>
  <div>
    <Launcher />
  </div>
</template>

<script>
import Launcher from "./Launcher.vue";

export default {
  components: {
    Launcher
  },
  mounted() {}
};
</script>

<style></style>
